import { SearchCriteriaQuerySentimentsEnum } from '../../../api/mentions/enum/search-criteria-query-sentiments.enum';
import { ChartMetricsEnum } from '../enums/chart-metrics.enum';


export const chartMetricsToSentimentsMap = new Map<ChartMetricsEnum, SearchCriteriaQuerySentimentsEnum>([
    [ChartMetricsEnum.positiveSentimentPercentage, SearchCriteriaQuerySentimentsEnum.positive],
    [ChartMetricsEnum.neutralSentimentPercentage, SearchCriteriaQuerySentimentsEnum.neutral],
    [ChartMetricsEnum.negativeSentimentPercentage, SearchCriteriaQuerySentimentsEnum.negative],
    [ChartMetricsEnum.POSITIVE, SearchCriteriaQuerySentimentsEnum.positive],
    [ChartMetricsEnum.NEUTRAL, SearchCriteriaQuerySentimentsEnum.neutral],
    [ChartMetricsEnum.NEGATIVE, SearchCriteriaQuerySentimentsEnum.negative],
]);

export const sentimentPercentMetrics = [
    ChartMetricsEnum.positiveSentimentPercentage,
    ChartMetricsEnum.neutralSentimentPercentage,
    ChartMetricsEnum.negativeSentimentPercentage
] as ChartMetricsEnum[];
